import { Tc } from '../../../core/_infrastructure/types/common';
import { TClaveCertCanariasViewModel } from '../datosbasicos/datosbasicosEx.types';
import { CopiaCertificadoExViewModel } from './copiaCF/copiaCFEx.types';
import { NumeroSeguridadViewModel } from './numerosseguridad/numerosseguridad.types';

export class SolicitudEnvioExViewModel {
    constructor() {}

    public Id: number;
    public Codigo: string;
    public IdTipoSolicitudEx = 0;
    public IdEstadoSolicitudEx = 0;
    public IdEstadoCertificadoFitoEx = 0;
    public IdResultadoEnvioMuestrasLaboratorioEx: number | null;
    public DescripcionIdResultadoEnvioMuestrasLaboratorioEx: string;
    public IdIdioma = 0;
    public IdiomaDescripcion: string;
    public EsPrevia = false;
    public TieneAlegacion = false;
    public FechaEnvio: Date | null;
    public ApellidosInspector = '';
    public NombreInspector = '';
    public FechaCreacion: Date;
    public FechaPresentacion: Date | null;
    public IdInspector: number | null = null;
    public EsEphyto: boolean;
    public NumeroCertificado: string;
    public FechaCertificacion: Date | null;
    public Referencia: string;
    public CfUtilizado: boolean;
    public CfDisponible: boolean;
    public Enviando = false;
    public IdSubTipoSolicitudEx: number | null;
    public IdSubTipoSolicitudExDescripcion: string;

    public TcTipoSolicitudEx: TcTipoSolicitudExViewModel = new TcTipoSolicitudExViewModel();
    public TcEstadoSolicitudEx: Tc;
    public TwTcEstadoCertificadoFitoEx: Tc;

    public TDatosSedeDocBDEx: TDatosSedeDocBDExViewModel = new TDatosSedeDocBDExViewModel();
    public TwSolicitudJerarquiaEx: TwSolicitudJerarquiaExViewModel = new TwSolicitudJerarquiaExViewModel();
    public TClaveCertCanarias: TClaveCertCanariasViewModel = new TClaveCertCanariasViewModel();

    public TCopiaCertificadoExCollection: CopiaCertificadoExViewModel[];
    public TSeguridadCertificadoFitoCollection: NumeroSeguridadViewModel[];
}

export class TwSolicitudJerarquiaExViewModel {
    public IdSolicitudEx: number;
    public IdSolicitudPadre: number;
    public IdTipoClonacion: number;
    public Guardada: boolean;
}

export class TcTipoSolicitudExViewModel {
    public Id: number;
    public Descripcion: string;
    public Codigo: string;
}

export class TDatosSedeDocBDExViewModel {
    public IdSolicitudEx: number;
    public Token: string;
    public IdDocSede: string;
    public Url: string;
    public VersionSede: string;
}

export class AuxEnvioExViewModel {
    public IdSolicitudEx: number;
    public IdUsuario: number;
    public IdCopia: number;
    public IdIdioma: number;
}

//petición post, para enviar ePhyto con documentos adjuntos
export class EPhytoSubmitPostRequest {
    public IdSolicitudEx: number;
    public IdIdioma: number;
    public DocumentosIdList: number[] = [];
}
